import Form from 'react-bootstrap/Form';

function OfficialsSection({
  values,
  handleChange,
  handleBlur,
  errors,
  disabled,
}) {
  return (
    <div className='d-flex flex-column gap-3'>
      <h5 id='section-officers' className='mt-4'>
        Funktionärer
      </h5>

      <Form.Group controlId='Officials.CompetitionManager'>
        <Form.Label>Tävlingsledare</Form.Label>
        <Form.Control
          placeholder='Ange tävlingsledare'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Officials?.CompetitionManager}
          value={values.Officials?.CompetitionManager}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Officials?.CompetitionManager}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Officials.AssistantCompetitionManager'>
        <Form.Label>Biträdande tävlingsledare</Form.Label>
        <Form.Control
          placeholder='Ange biträdande tävlingsledare'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Officials?.AssistantCompetitionManager}
          value={values.Officials?.AssistantCompetitionManager}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Officials?.AssistantCompetitionManager}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Officials.RaceController'>
        <Form.Label>Racecontroller</Form.Label>
        <Form.Control
          placeholder='Ange racecontroller'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Officials?.RaceController}
          value={values.Officials?.RaceController}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Officials?.RaceController}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Officials.Judge'>
        <Form.Label>Domare</Form.Label>
        <Form.Control
          placeholder='Ange domare'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Officials?.Judge}
          value={values.Officials?.Judge}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Officials?.Judge}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Officials.TechnicalManager'>
        <Form.Label>Teknisk chef</Form.Label>
        <Form.Control
          placeholder='Ange teknisk chef'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Officials?.TechnicalManager}
          value={values.Officials?.TechnicalManager}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Officials?.TechnicalManager}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Officials.SecurityManager'>
        <Form.Label>Säkerhetschef</Form.Label>
        <Form.Control
          placeholder='Ange säkerhetschef'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Officials?.SecurityManager}
          value={values.Officials?.SecurityManager}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Officials?.SecurityManager}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Officials.EnvironmentManager'>
        <Form.Label>Miljöchef</Form.Label>
        <Form.Control
          placeholder='Ange miljöchef'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Officials?.EnvironmentManager}
          value={values.Officials?.EnvironmentManager}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Officials?.EnvironmentManager}
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  );
}

export default OfficialsSection;
